import { Button, Form, Input, Modal, Upload } from 'antd';
import React from 'react';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';

const SubmissionSubmitModal = ({
    isOpen,
    onCancel,
    setFileList,
    onFileChange,
    onOk,
}) => {
    const { t } = useTranslation();
    const csrfToken = Cookies.get('csrftoken');

    const beforeUpload = (file) => {
        setFileList([file]);
        return false;
    };

    return (
        <Modal
            title={t('uploadSubmission.header')}
            open={isOpen}
            onCancel={onCancel}
            footer={null}
        >
            <Form
                name="create-new-course-step-submission"
                initialValues={{ remember: true }}
                onFinish={onOk}
                autoComplete="off"
                layout="vertical"
            >
                <Form.Item
                    label={t('uploadSubmission.title')}
                    name="title"
                    rules={[
                        {
                            required: true,
                            message: t('uploadSubmission.titleMissingWarning') as string,
                        },
                    ]}
                >
                    <Input data-cy="course-step-add-submission-title" />
                </Form.Item>
                <Form.Item
                    label={t('uploadSubmission.description')}
                    name="description"
                    rules={[
                        {
                            required: true,
                            message: t('uploadSubmission.descriptionMissingWarning') as string,
                        },
                    ]}
                >
                    <Input.TextArea
                        data-cy="course-step-add-submission-description"
                        rows={4}
                    />
                </Form.Item>
                <Form.Item
                    name="file"
                    label={t('uploadSubmission.file')}
                    valuePropName="fileList"
                    getValueFromEvent={(e) => {
                        if (Array.isArray(e)) {
                            return e;
                        }
                        return e && e.fileList;
                    }}
                    rules={[
                        {
                            required: true,
                            message: t('uploadSubmission.fileMissingWarning') as string,
                        },
                    ]}
                >
                    <Upload.Dragger
                        withCredentials={true}
                        headers={
                            csrfToken ? { 'X-CSRFToken': csrfToken } : undefined
                        }
                        name="file"
                        // action={`/api/v1/course/${courseUUID}/step/${courseStep.uuid}/user-progress/${courseStep.user_progress.tracking_uuid}/submission`}
                        listType="picture"
                        maxCount={1}
                        beforeUpload={beforeUpload}
                        onChange={onFileChange}
                    >
                        <Button>{t('uploadSubmission.selectFile')}</Button>
                    </Upload.Dragger>
                </Form.Item>

                <Form.Item>
                    <Button
                        block
                        data-cy="course-step-add-submission-submit-button"
                        type="primary"
                        htmlType="submit"
                        style={{ float: 'right' }}
                    >
                        {t('submit')}
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default SubmissionSubmitModal;
